// Core
import styled from 'styled-components';

// Config
import { BREAKPOINTS } from '../../../../../../config/screen';

export const OverallStatusContainer = styled.div`
  /* Mobile First - Base styles for smallest devices (XS) */
  display: flex;
  padding: 0.5rem 1rem;
  justify-content: space-between;
  align-items: center;
  border-right: 1px solid ${({ theme }) => theme.color.crusherDashboard.borderColor};
  border-bottom: 1px solid ${({ theme }) => theme.color.crusherDashboard.borderColor};
  border-top: 1px solid ${({ theme }) => theme.color.crusherDashboard.borderColor};

  > p {
    font-size: 12px;
  };

  /* ******* TABLET (SM - 576px and up) ******* */
  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 1rem 1.5rem;

    > p {
      font-size: inherit;
    };
  };
`;

export const TankTempStatusContainer = styled.div`
  /* Mobile First - Base styles for smallest devices (XS) */
  display: flex;
  padding: 0.5rem 1rem;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.color.crusherDashboard.borderColor};
  border-top: 1px solid ${({ theme }) => theme.color.crusherDashboard.borderColor};

  > p {
    font-size: 12px;
  };

  /* ******* TABLET (SM - 576px and up) ******* */
  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 1rem 1.5rem;

    > p {
      font-size: inherit;
    };
  };
`;

export const ClampPressureContainer = styled.div`
  border-right: 1px solid ${({ theme }) => theme.color.crusherDashboard.borderColor};
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 1rem;
  min-width: 50%;
`;

export const TrampPressureContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
`;

export const HydraulicContainer = styled.div`
  background-color: ${({ theme }) => theme.color.crusherDashboard.modulesBackgroundColor};
  height: 100%;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
`;

export const SpeedometersContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
`;
